<template>
<el-row :gutter="20">
  <el-col :span="24">
    <!-- <el-col :span="12" :offset="6"> -->
    <div class="success-box">
      <div class="setting-title clearfix">
        <div class="setting-info pull-left">{{ title }}</div>
        <div class="settingLine"></div>
      </div>
      <div class="account-box">
        <div class="settingMain">
          <img src="../../../assets/pic_success.png" alt="">
          <h3>Successful !</h3>
          <p>You can use your new {{ msg }} to log into the website</p>
        </div>
      </div>
    </div>
  </el-col>
</el-row>
</template>

<script>
export default {
  name: 'successBox',
  componentName: 'successBox',
  watch: {
    msg(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.msg = newVal
      }
    },
    title(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.title = newVal
      }
    }
  },
  props: {
    title: {
      type: String
    },
    msg: {
      type: String
    }
  },
  data() {
    return {
      msg1: '',
      title1: ''
    }
  },
  methods: {
    cb(msg) {
      this.msg1 = msg
    },
    cb1(title) {
      this.title = title
    }
  }
}
</script>

<style lang="scss">
.success-box {}

.setting-title {
  height: 21px;
  margin-bottom: 1rem;
}
.account-box {
  background-color: rgba(243, 245, 248, 0.5);
  padding: 2rem 2rem 9rem;

  .setting-info {
    height: 2.5rem;
    font-size: 1.875rem;
    font-weight: 700;
    line-height: 2.5rem;
    color: #2F457C;
  }

  .settingLine {
    overflow: hidden;
    height: 0.125rem;
    background-color: #F9FAFB;
  }

  .settingMain {
    // width: 30rem;
    // height: 15rem;
    margin: 3rem auto 0;
    text-align: center;

    img {
      width: 7.5rem;
      height: 7.5rem;
    }

    h3 {
      font-size: 1.625rem;
      height: 2.5rem;
      line-height: 2.5rem;
      color: #04B259;
    }

    p {
      font-size: 1.125rem;
      color: #6A798E;
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/successBox/src/main.vue